module.exports = __webpack_public_path__ + "static/media/Thumb_1920x384_Tesla_Seek.9c08f9e1.jpeg";